import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "sidebar-header-actions" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header-actions__delimiter" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_ActionsDropdown = _resolveComponent("ActionsDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.visibleActions.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.visibleActions, ({ name, icon }) => {
          return (_openBlock(), _createBlock(_component_NButton, {
            type: "text",
            icon: icon,
            onClick: ($event: any) => (_ctx.dispatchAction(name)),
            key: name,
            "data-qa": _ctx.dataQa + '.action.' + name
          }, null, 8, ["icon", "onClick", "data-qa"]))
        }), 128))
      : _createCommentVNode("", true),
    (_ctx.hiddenActions.length)
      ? (_openBlock(), _createBlock(_component_ActionsDropdown, {
          key: 1,
          actions: _ctx.hiddenActions,
          placement: "bottom-start",
          onAction: _ctx.dispatchAction,
          disableActions: _ctx.disableActions,
          "data-qa": _ctx.dataQa + '.actions'
        }, null, 8, ["actions", "onAction", "disableActions", "data-qa"]))
      : _createCommentVNode("", true),
    _hoisted_2,
    (_ctx.hasClose)
      ? (_openBlock(), _createBlock(_component_NButton, {
          key: 2,
          type: "text",
          icon: "close",
          onClick: _ctx.dispatchActionClose,
          "data-qa": _ctx.dataQa + '.close'
        }, null, 8, ["onClick", "data-qa"]))
      : _createCommentVNode("", true),
    (_ctx.hasToggle)
      ? (_openBlock(), _createBlock(_component_NButton, {
          key: 3,
          class: "sidebar-header-actions__toggle",
          type: "text",
          icon: "arrow-right",
          round: "",
          onClick: _ctx.dispatchActionToggle,
          "data-qa": _ctx.dataQa + '.toggle'
        }, null, 8, ["onClick", "data-qa"]))
      : _createCommentVNode("", true)
  ]))
}